import { create } from 'zustand';
import { uploadComplaintImage } from '../features/complaints/services/complaintsAPI';

export interface UploadTask {
  complaintId: number;
  totalFiles: number;
  uploadedFiles: number;
  status: 'uploading' | 'completed' | 'error';
  errorMessage?: string;
}

interface UploadStore {
  tasks: Record<number, UploadTask>;
  startUpload: (complaintId: number, images: File[], labelImages: File[]) => Promise<void>;
  dismissTask: (complaintId: number) => void;
}

export const useUploadStore = create<UploadStore>((set, get) => ({
  tasks: {},
  startUpload: async (complaintId, images, labelImages) => {
    const totalFiles = images.length + labelImages.length;
    
    if (totalFiles === 0) return;

    set(state => ({
      tasks: {
        ...state.tasks,
        [complaintId]: {
          complaintId,
          totalFiles,
          uploadedFiles: 0,
          status: 'uploading'
        }
      }
    }));

    try {
      // Upload sequentially as backend updates an array inside JSON
      for (const file of images) {
        await uploadComplaintImage(complaintId, file, 'foto');
        set(state => ({
          tasks: {
            ...state.tasks,
            [complaintId]: {
              ...state.tasks[complaintId],
              uploadedFiles: state.tasks[complaintId].uploadedFiles + 1
            }
          }
        }));
      }
      for (const file of labelImages) {
        await uploadComplaintImage(complaintId, file, 'etiqueta');
        set(state => ({
          tasks: {
            ...state.tasks,
            [complaintId]: {
              ...state.tasks[complaintId],
              uploadedFiles: state.tasks[complaintId].uploadedFiles + 1
            }
          }
        }));
      }
      
      set(state => ({
        tasks: {
          ...state.tasks,
          [complaintId]: {
            ...state.tasks[complaintId],
            status: 'completed'
          }
        }
      }));
      
      // Auto dismiss after 5 seconds
      setTimeout(() => {
        get().dismissTask(complaintId);
      }, 5000);
      
    } catch (error: any) {
      console.error('Upload background error:', error);
      set(state => ({
        tasks: {
          ...state.tasks,
          [complaintId]: {
            ...state.tasks[complaintId],
            status: 'error',
            errorMessage: error?.response?.data?.error || 'Erro ao enviar imagens'
          }
        }
      }));
      
      // Rethrow to allow awaiting components to handle failure
      throw error;
    }
  },
  dismissTask: (complaintId) => {
    set(state => {
      const newTasks = { ...state.tasks };
      delete newTasks[complaintId];
      return { tasks: newTasks };
    });
  }
}));
